import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { PatientListPageComponent } from './patient-list-page/patient-list-page.component';
import { CreatePatientPageComponent } from './create-patient-page/create-patient-page.component';
import { PatientDashboardComponent } from './dashboard-page/dashboard-page.component';
import { DashboardCanDeactivateGuard } from '../calvin-emr-shared/guards/dashboard-can-deactivate.guard';
import { AuthGuard } from '../calvin-emr-shared/guards/auth.guard';
import { AdminGuard } from '../calvin-emr-shared/guards/admin.guard';
import {
  PATH_PATIENTS,
  PATH_CREATE_PATIENT,
  PATH_ID_PARAM,
  PATH_ROLE_PARAM,
  PATH_EDIT_PATIENT,
  PATH_PATIENTS_LIST,
  PATH_PATIENT_DASHBOARD,
} from './patients.global';
import { PatientsHomePageComponent } from './patients-home-page/patients-home-page';
import { PATH_LOGIN } from 'src/app/login/login.global';

export const patientsRoutes: Routes = [
  {
    path: PATH_PATIENTS,
    component: PatientsHomePageComponent,
    canActivate: [() => inject(AuthGuard).canActivate(PATH_LOGIN)],
    canActivateChild: [() => inject(AuthGuard).canActivateChild(PATH_LOGIN)],
    children: [
      { path: '', redirectTo: PATH_PATIENTS_LIST, pathMatch: 'full' },
      { path: PATH_PATIENTS_LIST, component: PatientListPageComponent },
      {
        path: `${PATH_PATIENT_DASHBOARD}/:${PATH_ROLE_PARAM}/:${PATH_ID_PARAM}`,
        component: PatientDashboardComponent,
        canDeactivate: [DashboardCanDeactivateGuard],
      },
      {
        path: PATH_CREATE_PATIENT,
        component: CreatePatientPageComponent,
        canActivate: [() => inject(AdminGuard).canActivate(PATH_PATIENTS)],
      },
      {
        path: `${PATH_EDIT_PATIENT}/:${PATH_ID_PARAM}`,
        component: CreatePatientPageComponent,
        canActivate: [() => inject(AdminGuard).canActivateChild(PATH_PATIENTS)],
      },
    ],
  },
];
